import { useState, useEffect } from 'react';
import { collection, query, where, onSnapshot, getDocs } from 'firebase/firestore';
import { db } from '../config/firebase';

/**
 * Hook to fetch total fund fees collected
 * Fees come from performance fees and early redemption fees
 */
export const useFundFees = (realtime: boolean = false) => {
  const [fundFees, setFundFees] = useState<number>(0);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState<Error | null>(null);

  useEffect(() => {
    if (realtime) {
      // Real-time listener
      const q = query(
        collection(db, 'poolNAV'),
        where('__name__', '==', 'current')
      );

      const unsubscribe = onSnapshot(
        q,
        (snapshot) => {
          if (!snapshot.empty) {
            const doc = snapshot.docs[0];
            const fees = doc.data().fundFees || 0;
            setFundFees(fees);
          } else {
            setFundFees(0);
          }
          setLoading(false);
        },
        (err) => {
          console.error('Error fetching fund fees:', err);
          setError(err as Error);
          setLoading(false);
        }
      );

      return () => unsubscribe();
    } else {
      // One-time fetch
      const fetchFundFees = async () => {
        try {
          const q = query(
            collection(db, 'poolNAV'),
            where('__name__', '==', 'current')
          );
          const snapshot = await getDocs(q);
          
          if (!snapshot.empty) {
            const doc = snapshot.docs[0];
            const fees = doc.data().fundFees || 0;
            setFundFees(fees);
          } else {
            setFundFees(0);
          }
          setLoading(false);
        } catch (err) {
          console.error('Error fetching fund fees:', err);
          setError(err as Error);
          setLoading(false);
        }
      };

      fetchFundFees();
    }
  }, [realtime]);

  return { fundFees, loading, error };
};
